// PN-8 / PN-11 (T-430) — le menu « Outils avancés » de la fiche : ce qui est technique ou irréversible y est rangé, hors de la barre
// d'actions de tous les jours. `entrees` = [{ id, label, icon, onClick, danger, disabled }] ; sans entrée, rien n'est rendu (pas même un bouton).
import { Wrench } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../../components/ui/dropdown-menu";

export function OutilsAvancesMenu({ entrees = [] }) {
  const utiles = entrees.filter(Boolean);
  if (!utiles.length) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="outils-avances-btn" size="sm" variant="ghost" className="text-xs h-7 px-2 gap-1.5" aria-label="Outils avancés"
          title="Outils réservés aux administrateurs de la plateforme">
          <Wrench className="w-3.5 h-3.5" style={{ color: "var(--oh-text-muted)" }} />
          <span className="hidden sm:inline">Outils avancés</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        {utiles.map((e) => (
          <DropdownMenuItem key={e.id} data-testid={`outil-${e.id}`} disabled={e.disabled} onClick={e.onClick}
            className={e.danger ? "text-[var(--oh-error-text)]" : ""}>
            {e.icon && <e.icon className="w-4 h-4 mr-2" />}{e.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
